export default __webpack_public_path__ + "static/media/mygateway_logo_no_text.382850ff.png";